import { ref } from 'vue'

export const PRIVACY_STORAGE_KEY = 'sensitive'

export const PRIVACY_SWITCH = {
  CLOSE: '0', // 脱敏
  OPEN: '1', // 不脱敏
}

// 隐私开关状态（模块级单例）
export const privacyState = ref(PRIVACY_SWITCH.CLOSE)

export const getPrivacyLocal = () => {
  return localStorage.getItem(PRIVACY_STORAGE_KEY)
}

export const modifyPrivacyLocal = (val) => {
  privacyState.value = val.toString()
  localStorage.setItem(PRIVACY_STORAGE_KEY, val)
}
